(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90324,33051,98162],{

/***/ 59870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ChallengesAndSolutions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./UI/containers/CustomSwiper/index.jsx + 2 modules
var CustomSwiper = __webpack_require__(33051);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./UI/components/ChallengesSlider/styles.module.scss
var styles_module = __webpack_require__(36157);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/ChallengesSlider/utils/challengesSliderHelper.js




var getSwiperParams = function(type) {
    var pagination = type === constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider ? {} : {
        spaceBetween: 50,
        autoHeight: true,
        pagination: {
            type: "bullets",
            clickable: true,
            bulletClass: (styles_module_default()).swiperBullet,
            bulletActiveClass: (styles_module_default()).swiperBulletActive
        }
    };
    return (0,_object_spread/* default */.Z)({
        modules: [
            swiper_esm/* Pagination */.tl
        ]
    }, pagination);
};

;// CONCATENATED MODULE: ./UI/components/ChallengesSlider/utils/useChallengesSlider.js


var useChallengesSlider = function(param) {
    var type = param.type, componentType = param.componentType, isMobileResolution = param.isMobileResolution, isSlider = param.isSlider, children = param.children;
    var isSpecialSwiper = componentType === constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider;
    var swiperParams = getSwiperParams(componentType);
    return {
        type: type,
        isMobileResolution: isMobileResolution,
        isSlider: isSlider,
        children: children,
        isSpecialSwiper: isSpecialSwiper,
        swiperParams: swiperParams
    };
};

;// CONCATENATED MODULE: ./UI/components/ChallengesSlider/index.jsx







var ChallengesSlider = function(props) {
    var ref = useChallengesSlider(props), type = ref.type, isMobileResolution = ref.isMobileResolution, isSlider = ref.isSlider, children = ref.children, isSpecialSwiper = ref.isSpecialSwiper, swiperParams = ref.swiperParams;
    if (!isMobileResolution || !isSlider) return children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper["default"], {
        className: classnames_default()((styles_module_default()).swiper, (styles_module_default())[type]),
        swiperParams: swiperParams,
        isShowNavigation: isSpecialSwiper,
        navigationClassName: (styles_module_default()).navigation,
        children: children.map(function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: child
            }, index);
        })
    });
};
ChallengesSlider.defaultProps = {
    isMobileResolution: false
};
ChallengesSlider.propTypes = {
    isSlider: (prop_types_default()).bool.isRequired,
    children: prop_types_default().arrayOf((prop_types_default()).node).isRequired,
    type: (prop_types_default()).string.isRequired,
    componentType: (prop_types_default()).string.isRequired,
    isMobileResolution: (prop_types_default()).bool
};
/* harmony default export */ var components_ChallengesSlider = (ChallengesSlider);

// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/ChallengesAndSolutions/utils/helpers.js

var disabledSlider = function(type) {
    return ![
        constants/* CASE_STUDIES.generativeAi */.qU.generativeAi, 
    ].includes(type);
};

;// CONCATENATED MODULE: ./UI/components/ChallengesAndSolutions/utils/useChallengesAndSolutions.js






var useChallengesAndSolutions = function(param) {
    var data = param.data, type = param.type, isSpecial = param.isSpecial, view = param.view;
    var componentType = data.type, contentModules = data.contentModules, rawImages = data.images;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isSlider = [
        constants/* CASE_STUDIES_TYPES.challengesSlider */.vA.challengesSlider,
        constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider
    ].includes(data.type);
    var isSliderDisabled = disabledSlider(type);
    var images = (rawImages || []).map(function(rawImage) {
        return (0,helper/* getImage */.gJ)(rawImage);
    });
    var content = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(document) {
        var ref = (0,helper/* getDocumentFields */.OA)(document), title = ref.title, blockImages = ref.images, text = ref.text, imagesBundles = ref.imagesBundles, subtitle = ref.subtitle, _contentList = ref.contentList, contentList = _contentList === void 0 ? [] : _contentList;
        var subImage = (0,helper/* getImage */.gJ)(get_default()(blockImages, "[1]", ""));
        var imagesBundlesWithUrl = (imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(bundle) {
            return (0,helper/* getImage */.gJ)(bundle);
        })) || [];
        return {
            title: title,
            text: text,
            subtitle: subtitle,
            contentList: contentList,
            asset: !!(blockImages === null || blockImages === void 0 ? void 0 : blockImages[0]) && blockImages[0],
            subImage: subImage,
            imagesBundles: imagesBundlesWithUrl
        };
    });
    return {
        type: type,
        isSpecial: isSpecial,
        view: view,
        isSlider: isSlider,
        isMobileResolution: isMobileResolution,
        content: content,
        componentType: componentType,
        images: images,
        isSliderDisabled: isSliderDisabled
    };
};

// EXTERNAL MODULE: ./UI/components/ChallengesAndSolutions/styles.module.scss
var ChallengesAndSolutions_styles_module = __webpack_require__(92764);
var ChallengesAndSolutions_styles_module_default = /*#__PURE__*/__webpack_require__.n(ChallengesAndSolutions_styles_module);
;// CONCATENATED MODULE: ./UI/components/ChallengesAndSolutions/index.jsx















var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var ChallengesAndSolutions = function(props) {
    var ref = useChallengesAndSolutions(props), type = ref.type, isSpecial = ref.isSpecial, view = ref.view, isSlider = ref.isSlider, isMobileResolution = ref.isMobileResolution, content = ref.content, componentType = ref.componentType, images = ref.images, isSliderDisabled = ref.isSliderDisabled;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ChallengesAndSolutions_styles_module_default())[type], (ChallengesAndSolutions_styles_module_default())[view]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChallengesSlider, {
                isMobileResolution: isMobileResolution,
                isSlider: isSlider && isSliderDisabled,
                componentType: componentType,
                type: type,
                children: content === null || content === void 0 ? void 0 : content.map(function(param, index) {
                    var title = param.title, text = param.text, imagesBundles = param.imagesBundles, subtitle = param.subtitle, contentList = param.contentList, image = param.image, subImage = param.subImage, asset = param.asset;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((ChallengesAndSolutions_styles_module_default()).contentContainer, (ChallengesAndSolutions_styles_module_default())["contentContainer-".concat(index + 1)], (0,_define_property/* default */.Z)({}, (ChallengesAndSolutions_styles_module_default()).special, isSpecial)),
                        children: [
                            !asset && title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((ChallengesAndSolutions_styles_module_default()).infoContainer, (ChallengesAndSolutions_styles_module_default()).separatedTitle),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                        variant: "h2",
                                        className: (ChallengesAndSolutions_styles_module_default()).title,
                                        children: title
                                    })
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).infoContainer, (ChallengesAndSolutions_styles_module_default())["infoContainer-".concat(index + 1)], (0,_define_property/* default */.Z)({}, (ChallengesAndSolutions_styles_module_default()).centrefy, asset)),
                                children: [
                                    subImage.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                        transparent: true,
                                        className: (ChallengesAndSolutions_styles_module_default()).subImage,
                                        src: subImage.url,
                                        alt: subImage.alt
                                    }),
                                    asset && subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                variant: "p",
                                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).subtitle, (ChallengesAndSolutions_styles_module_default())["subtitle-".concat(index + 1)]),
                                                children: subtitle
                                            })
                                        })
                                    })),
                                    asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                variant: "h2",
                                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).title, (ChallengesAndSolutions_styles_module_default())["title-".concat(index + 1)]),
                                                children: title
                                            })
                                        })
                                    })),
                                    text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        delay: 100
                                    }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                            document: text
                                        })
                                    })),
                                    !!contentList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (ChallengesAndSolutions_styles_module_default()).listContainer,
                                        children: contentList === null || contentList === void 0 ? void 0 : contentList.map(function(item, contentIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                delay: 50 + 10 * contentIndex
                                            }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (ChallengesAndSolutions_styles_module_default()).listItem,
                                                    children: item
                                                })
                                            }));
                                        })
                                    })
                                ]
                            }),
                            (asset || !!imagesBundles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((ChallengesAndSolutions_styles_module_default()).images, (ChallengesAndSolutions_styles_module_default())["images-".concat(index + 1)]),
                                    children: [
                                        asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                                            asset: asset,
                                            className: classnames_default()((ChallengesAndSolutions_styles_module_default()).image, (ChallengesAndSolutions_styles_module_default())["image-".concat(index + 1)])
                                        }),
                                        imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(imageBundle, imagesBundlesIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                                transparent: true,
                                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).imageBundle, (ChallengesAndSolutions_styles_module_default())["imageBundle-".concat(imagesBundlesIndex + 1)]),
                                                src: imageBundle.url,
                                                alt: imageBundle.alt
                                            }, "bundles-images/".concat(imageBundle.url));
                                        })
                                    ]
                                })
                            }))
                        ]
                    }, title || image);
                })
            }),
            !!images.length && images.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    src: image.url,
                    className: (ChallengesAndSolutions_styles_module_default()).sectionImage
                }, image.url);
            })
        ]
    });
};
ChallengesAndSolutions.defaultProps = {
    type: "",
    isSpecial: false,
    view: ""
};
ChallengesAndSolutions.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string,
    isSpecial: (prop_types_default()).bool,
    view: (prop_types_default()).string
};
/* harmony default export */ var components_ChallengesAndSolutions = (ChallengesAndSolutions);


/***/ }),

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (renderVideoPlayer) {
            return renderVideoPlayer({
                src: url,
                description: imageProps.alt
            });
        }
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 70731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SwiperNavButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/utils/useSwiperNavButton.js



var useSwiperNavButton = function(_param) {
    var buttonRef = _param.buttonRef, type = _param.type, text = _param.text, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonRef",
        "type",
        "text",
        "className"
    ]);
    var svgType = type === "next" ? "arrowRight" : "arrowLeft";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        buttonRef: buttonRef,
        type: type,
        text: text,
        svgType: svgType,
        className: className
    });
};

// EXTERNAL MODULE: ./UI/components/SwiperNavButton/styles.module.scss
var styles_module = __webpack_require__(5713);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/index.jsx









var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var SwiperNavButton = function(props) {
    var _ref = useSwiperNavButton(props), buttonRef = _ref.buttonRef, type = _ref.type, text = _ref.text, svgType = _ref.svgType, className = _ref.className, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "buttonRef",
        "type",
        "text",
        "svgType",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: classnames_default()(className, (styles_module_default()).navButton, (styles_module_default())[type]),
        ref: buttonRef,
        "data-swiper-button": true
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: svgType
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).text,
                children: text
            })
        ]
    }));
};
SwiperNavButton.defaultProps = {
    className: "",
    text: ""
};
SwiperNavButton.propTypes = {
    type: prop_types_default().oneOf([
        "next",
        "prev"
    ]).isRequired,
    text: (prop_types_default()).string,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_SwiperNavButton = (SwiperNavButton);


/***/ }),

/***/ 33051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_CustomSwiper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SwiperNavButton/index.jsx + 1 modules
var SwiperNavButton = __webpack_require__(70731);
// EXTERNAL MODULE: ./UI/components/SwiperNavigation/styles.module.scss
var styles_module = __webpack_require__(35133);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavigation/index.jsx





var SwiperNavigation = function(param) {
    var className = param.className, navigationPrevRef = param.navigationPrevRef, navigationNextRef = param.navigationNextRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, (styles_module_default()).navigationContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "prev",
                text: "previous",
                buttonRef: navigationPrevRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "next",
                text: "next",
                buttonRef: navigationNextRef
            })
        ]
    });
};
SwiperNavigation.defaultProps = {
    className: null
};
SwiperNavigation.propTypes = {
    className: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/utils/useCustomSwiper.js

var useCustomSwiper = function(param) {
    var children = param.children, swiperParams = param.swiperParams, isShowNavigation = param.isShowNavigation, navigationClassName = param.navigationClassName, className = param.className;
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var onSwiperInit = function(swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    };
    return {
        children: children,
        swiperParams: swiperParams,
        isShowNavigation: isShowNavigation,
        navigationClassName: navigationClassName,
        className: className,
        navigationPrevRef: navigationPrevRef,
        navigationNextRef: navigationNextRef,
        onSwiperInit: onSwiperInit
    };
};

;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/index.jsx









var CustomSwiper = function(props) {
    var ref = useCustomSwiper(props), children = ref.children, swiperParams = ref.swiperParams, isShowNavigation = ref.isShowNavigation, navigationClassName = ref.navigationClassName, className = ref.className, navigationNextRef = ref.navigationNextRef, navigationPrevRef = ref.navigationPrevRef, onSwiperInit = ref.onSwiperInit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperParams), {
        onInit: isShowNavigation ? onSwiperInit : undefined,
        modules: (0,_to_consumable_array/* default */.Z)(swiperParams.modules || []).concat([
            swiper_esm/* Navigation */.W_, 
        ]),
        className: className,
        children: [
            children,
            isShowNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavigation, {
                className: navigationClassName,
                navigationPrevRef: navigationPrevRef,
                navigationNextRef: navigationNextRef
            })
        ]
    }));
};
SwiperNavigation.defaultProps = {
    isShowNavigation: false,
    navigationClassName: null
};
SwiperNavigation.propTypes = {
    isShowNavigation: (prop_types_default()).bool,
    navigationClassName: (prop_types_default()).string,
    swiperParams: prop_types_default().instanceOf(Object),
    children: prop_types_default().arrayOf((prop_types_default()).node)
};
/* harmony default export */ var containers_CustomSwiper = (CustomSwiper);


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7002).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType;
                        return tableContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 92764:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"styles_contentContainer__sScq9","centrefy":"styles_centrefy__5RDMv","infoContainer":"styles_infoContainer__LUqIG","listContainer":"styles_listContainer__lHap1","listItem":"styles_listItem__vdwfS","separatedTitle":"styles_separatedTitle__t5Way","title":"styles_title__vJ0p8","image":"styles_image__MjRwD","imageBundle":"styles_imageBundle__whWXD","subImage":"styles_subImage__GVoGI","stickerbox":"styles_stickerbox__lLJaT","special":"styles_special__GMGAv","swiperBullet":"styles_swiperBullet__wpIqr","swiperBulletActive":"styles_swiperBulletActive__tUY7f","fireaway":"styles_fireaway__mxlHq","contentContainer-3":"styles_contentContainer-3__GZqIA","images":"styles_images__K9iF0","images-1":"styles_images-1__FvgdQ","images-2":"styles_images-2__5Z4GJ","contentContainer-2":"styles_contentContainer-2__CtrxU","fairy":"styles_fairy__BrQF7","firstSectionView":"styles_firstSectionView__eerpF","image-1":"styles_image-1__viHF5","secondSectionView":"styles_secondSectionView__yg7zP","seven-pm-thursday":"styles_seven-pm-thursday__n9iBu","contentContainer-1":"styles_contentContainer-1__hvFWf","infoContainer-1":"styles_infoContainer-1__pkeve","image-2":"styles_image-2__V1jCK","image-3":"styles_image-3__DpbU5","fernwayer":"styles_fernwayer__T0RzM","thirdSectionView":"styles_thirdSectionView__NDA0d","drive-focus":"styles_drive-focus__bLSTM","fourthSectionView":"styles_fourthSectionView__H1dZE","infoContainer-2":"styles_infoContainer-2__sSgGv","hotel-data-cloud":"styles_hotel-data-cloud__76Un6","infoContainer-3":"styles_infoContainer-3__7OX9C","open-sense":"styles_open-sense__1Bi9f","infoContainer-4":"styles_infoContainer-4___IHDo","image-4":"styles_image-4__wPsVe","separate-us":"styles_separate-us__gPMxx","h3":"styles_h3___R3DB","famlicious":"styles_famlicious__KUV8C","imageBundle-1":"styles_imageBundle-1__HP7VN","contentContainer-4":"styles_contentContainer-4__PQaWw","natp":"styles_natp__nYG3m","travel-trivia":"styles_travel-trivia__t4mFb","cash-chat":"styles_cash-chat__czmgK","tell":"styles_tell__plpO6","ubichat":"styles_ubichat__GfSHl","writer-chrome-extension":"styles_writer-chrome-extension__QUobD","meateater":"styles_meateater__m2yI_","contentContainer-6":"styles_contentContainer-6__KIU1K","image-5":"styles_image-5__PeRdz","bionorica":"styles_bionorica__U6AqF","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__q5_3T","fusion-markets":"styles_fusion-markets__KK4G9","beautonomy":"styles_beautonomy__PteJ4","telemojo":"styles_telemojo__oSl35","blackbird":"styles_blackbird__CgViD","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__omNSD","smartcenter":"styles_smartcenter__u4_Er","dindon":"styles_dindon__90HqL","infoContainer-5":"styles_infoContainer-5__mbxdr","contentContainer-5":"styles_contentContainer-5__DAHKl","humankind":"styles_humankind__FwOK1","cinnabar":"styles_cinnabar__OWfEz","contentContainer-7":"styles_contentContainer-7__FjtCD","imageBundle-2":"styles_imageBundle-2__vRoNY","imageBundle-3":"styles_imageBundle-3__W6F3e","imageBundle-4":"styles_imageBundle-4__g0I1G","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate___2IzS","mobile-bank-application":"styles_mobile-bank-application__ew_sD","fifthSectionView":"styles_fifthSectionView__2fbTI","software-for-mri-interpretation":"styles_software-for-mri-interpretation__qbFxL","cedar-valley-farms":"styles_cedar-valley-farms__n8x_j","mobile-budgeting-app":"styles_mobile-budgeting-app__V8H2z","forex-trading-platform":"styles_forex-trading-platform__vA3qg","why-us":"styles_why-us__LC_wd","crowdfunding-platform":"styles_crowdfunding-platform__EcpMN","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__gPbVc","cctv-footage-analytics":"styles_cctv-footage-analytics__AUm8f","web-chat-for-mediums":"styles_web-chat-for-mediums__ibtuk","web-p2p-lending-platform":"styles_web-p2p-lending-platform__Zp9rn","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__kmyUS","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__IFCVl","sectionImage":"styles_sectionImage__ZLQFz","digital-wallet-for-ios":"styles_digital-wallet-for-ios__tJeEh","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__5qVLl","ai-documentation-processing":"styles_ai-documentation-processing__V6R4C","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__tNHkC","images-3":"styles_images-3__FfzyZ","images-4":"styles_images-4__dgEWS","images-5":"styles_images-5__ZUWvg","ai-based-travel-planner":"styles_ai-based-travel-planner__Q4Faz","computer-vision-for-aras":"styles_computer-vision-for-aras__dKA5w","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__dIf9k","pen-testing-for-uk-web-dev-company":"styles_pen-testing-for-uk-web-dev-company__JQYqx","pen-tests-ai":"styles_pen-tests-ai__2uSkx","web-logistics-platform":"styles_web-logistics-platform__BkkQp","ai-feedback-analysis":"styles_ai-feedback-analysis___jKX2","ai-for-edtech":"styles_ai-for-edtech__cy0gE","ai-reporting-assistant":"styles_ai-reporting-assistant__loerc","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__x06ce","feedback-insight-engine":"styles_feedback-insight-engine__SeE1K"};

/***/ }),

/***/ 36157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiper":"styles_swiper__UwtVM","swiperBullet":"styles_swiperBullet__qWZCQ","swiperBulletActive":"styles_swiperBulletActive__bTtGm","stickerbox":"styles_stickerbox__8bLcQ","fairy":"styles_fairy__8bXbm","seven-pm-thursday":"styles_seven-pm-thursday__wfGyS","fernwayer":"styles_fernwayer__N9SO_","open-sense":"styles_open-sense__yRevP","separate-us":"styles_separate-us__6Qmf0","famlicious":"styles_famlicious__Zq_UJ","natp":"styles_natp__neWzF","travel-trivia":"styles_travel-trivia__Z1JFG","cash-chat":"styles_cash-chat__XgTga","tell":"styles_tell__pDQ6c","ubichat":"styles_ubichat__uH4gb","writer-chrome-extension":"styles_writer-chrome-extension__h3bXH","bionorica":"styles_bionorica__VdEMw","dindon":"styles_dindon__Jr5W_","cinnabar":"styles_cinnabar__AXqel","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__WK15H","mobile-budgeting-app":"styles_mobile-budgeting-app__lQ8Qi","thirdSectionView":"styles_thirdSectionView__7g3_z","forex-trading-platform":"styles_forex-trading-platform__QNFqc","web-chat-for-mediums":"styles_web-chat-for-mediums__Pq7uu","meateater":"styles_meateater__b_y3H","mobile-bank-application":"styles_mobile-bank-application__N_OKM","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__hynRR","ai-for-edtech":"styles_ai-for-edtech___FSPz"};

/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 5713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navButton":"styles_navButton___E8aQ","text":"styles_text__fy5hq","next":"styles_next__89xlm"};

/***/ }),

/***/ 35133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationContainer":"styles_navigationContainer__cgD9j"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ })

}]);